import React from 'react';
import { toJS } from 'mobx';
import './tips.scss';
import { inject, observer } from "mobx-react";
@inject("ScoreStore")
@observer
class Tips extends React.Component {
    state = {
        open: this.props.init ? true : false,
        guideTips: false,
        animation: false,
        aReverse: false
    }
    componentDidMount() {
        if (this.props.init) {
            this.summary.play();
        }
    }
    openTips() {
        if (this.state.open) {
            this.setState({
                animation: true
            }, () => {
                this.summary.pause();
                setTimeout(() => {
                    this.setState({
                        open: false,
                        animation: false
                    }, () => {
                        this.props.callBack && this.props.callBack();
                    })
                }, 200)
            })

        }
        else {
            this.setState({
                open: true,
                aReverse: true
            }, () => {
                setTimeout(() => {
                    this.setState({
                        animation: true
                    })
                }, 0)
                setTimeout(() => {
                    this.setState({
                        aReverse: false,
                        animation: false
                    })
                }, 200)
            })
        }

    }
    openGuide() {
        if (this.state.guideTips) {
            this.setState({
                animation: true
            }, () => {
                setTimeout(() => {
                    this.setState({
                        guideTips: false,
                        animation: false
                    })
                }, 200)
            })

        }
        else {
            this.setState({
                guideTips: true,
                aReverse: true
            }, () => {
                setTimeout(() => {
                    this.setState({
                        animation: true
                    })
                }, 0)
                setTimeout(() => {
                    this.setState({
                        aReverse: false,
                        animation: false
                    })
                }, 200)
            })
        }
    }
    audioPlay() {
        this.refs.button_audio.play();
    }
    render() {
        let classInfo = toJS(this.props.ScoreStore.classInfo);
        let tips = classInfo.tipsData[this.props.studyTips || 0].tips;
        return (
            <div>
                {this.state.open ? <div className="tips_cover"><div className={`tips_view ${this.state.aReverse ? "tips_scale" : ""} ${this.state.animation ? "tips_move" : ""}`}>
                    <i className="tips_close" onClick={() => { this.openTips() }}></i>
                    <div className="form_tit">病历摘要</div>
                    <div className="form_tips">附件1：病案<br />
                        患者，男，38岁，“反复腹泻3年，加重3天”就诊。患者于3年前不明原因出现腹泻，在工作紧张、情志不畅时就会出现大便稀薄，次数增多，日行2-3次，近2月病情加重，大便不成形，每日3-5次。平时有腹胀不适感，矢气频作。3天前与家人争吵后出现腹满胀痛，腹泻后痛减，时作时止。四诊：胸胁胀闷，嗳气食少，腹痛但无明显压痛，矢气频繁，大便呈糊状，无粘液脓血，舌红，苔薄白，脉弦。</div>
                    <div className="form_btn">
                        <audio ref={(e) => { this.summary = e }} src={require('../assets/audio/case_summary.mp3')} />
                        <button onClick={() => { this.openTips() }}>我已了解</button>
                    </div>
                </div></div> :
                    <div className="tips_icon" onClick={() => { this.openTips() }} onMouseOver={() => { this.audioPlay() }}>
                        <img src={require("../assets/images/icon_tips.png")} />
                    </div>}

                {
                    this.props.ScoreStore.studyType && <div>

                        {
                            this.state.guideTips ?
                                <div className="tips_cover"><div className={`tips_view ${this.state.aReverse ? "tips_scale" : ""} ${this.state.animation ? "tips_move" : ""}`}>
                                    <i className="tips_close" onClick={() => { this.openGuide() }}></i>
                                    <div className="form_tips" dangerouslySetInnerHTML={{ __html: tips }}></div>
                                </div></div> : <div className="tips_warning" onMouseOver={() => { this.audioPlay() }} onClick={() => { this.openGuide() }} >
                                    <img src={require("../assets/images/icon_warning.png")} />
                                </div>
                        } </div>
                }


                <audio ref="button_audio" src={require('../assets/audio/tips_button.mp3')} />
            </div>
        )
    }
}
export default Tips;